const isStorybook = import.meta.env.VITE_STORYBOOK === "true" ||
    (typeof window !== "undefined" && window.location.pathname.endsWith("/iframe.html"));
const configuredApiBaseUrl = isStorybook ? "" : (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || "/api";

export function resolveAPIBaseURL() {
    return configuredApiBaseUrl;
}

export function hasConfiguredBackend() {
    return configuredApiBaseUrl.length > 0;
}

export function buildBackendUrl(path: string) {
    return `${configuredApiBaseUrl}${path}`;
}
